/* 🤖 this file was generated by script */
export const wiconPause = {
  name: 'pause',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" d="M6 6a1 1 0 012 0v8a1 1 0 11-2 0V6zM12 6a1 1 0 112 0v8a1 1 0 11-2 0V6z"/></svg>`,
};
